import React from 'react';
import Amplify from 'aws-amplify';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withAlert } from 'react-alert';
import { getPageData } from '../../Actions/actions';
import * as SecretKeys from '../../ENV.json';
import Header from '../Header/header';

Amplify.configure(SecretKeys.awsUserpool);
class RevocableLetter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      details: [],
      userTypeFooter: localStorage.getItem('userTypeFooter'),

    };
  }

  componentDidMount() {
    const { userTypeFooter } = this.state;

    // this.props.getPageData(5);
    if (userTypeFooter === 'Consumer') {
      this.props.getPageData(9);
    } else if (userTypeFooter === 'Business-User') {
      this.props.getPageData(8);
    } else {
      this.props.getPageData(8);
    }
  }

  componentDidUpdate() {
    const { pageDetails } = this.props.data;
    const { details } = this.state;
    if (pageDetails !== undefined) {
      if (details !== pageDetails) {
        this.setState({
          details: pageDetails,
        });
      }
    }
  }

  render() {
    const { details } = this.state;
    const text = details.body;
    return (
      <span>
        <Header />
        <div className="section-content left-align term">
          <div className="row">
            <div className="col s12 m10 offset-m1">
              <div className="row">
                <div className="col s12">
                  <h4>{details.title}</h4>
                  <div className="content" dangerouslySetInnerHTML={{ __html: text }} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </span>
    );
  }
}

RevocableLetter.contextTypes = {
  router: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({ data: state.data });

const mapDispatchToProps = dispatch =>
  bindActionCreators({ getPageData }, dispatch);

export default withAlert(connect(mapStateToProps, mapDispatchToProps)(RevocableLetter));
